import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class NotAuthenticatedGuard implements CanActivate {
  // prevents confusion for when the user is already logged in.

  constructor(
    private router: Router
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (localStorage.getItem('currentUser')) {
      this.router.navigate(['todolist']);
      return false;
    }

    return true;
  }
}
